import {css} from '@yandex-delivery/blocks/theme/css'
import {spacing} from '@yandex-delivery/blocks/theme/theme'

export const root = css`
  overflow: visible;
  z-index: 2;
`

export const header = css`
  border-radius: ${spacing(3)};
  background-color: transparent;
`

export const backButton = css`
  inset-block-start: ${spacing(-8)};
  position: absolute;
  inset-inline-start: ${spacing(1.5)};
  z-index: 1;
`

export const geolocationControl = {
  root: css`
    inset-block-start: ${spacing(-8)};
    position: absolute;
    inset-inline-end: 0;
    z-index: 1;
  `,
}
